import dynamic from "next/dynamic";
import MondayFormFormConfig from "./monday-form-form-config";
import MondayFormFormAdvancedConfig from "./monday-form-form-advanced-config";
const MondayFormFormComponent = dynamic(()=>import("./monday-form-form-component"));
export default {
    MondayFormFormComponent,
    MondayFormFormConfig,
    MondayFormFormAdvancedConfig
};
